import * as React from "react";
import { pure } from "recompose";

import {
  AccountInfoContainer,
  PaymentDetailsContainer,
} from "../../../../containers/booking";

const Checkout: React.FC = () => {
  return (
    <React.Fragment>
      <AccountInfoContainer />
      <PaymentDetailsContainer />
    </React.Fragment>
  );
};

const pureComponent = pure(Checkout);

export { pureComponent as Checkout };
